import React, { Component } from 'react';
import createStyledComponent from '../utils/createStyledComponent.js';
import styles from './styles/index.js';
const SegmentedWrapper = createStyledComponent(styles);
export default class SegmentedControl extends Component {
    constructor() {
        super(...arguments);
        this.onClick = (e) => {
            this.props.onClick(e.currentTarget.value);
        };
        this.onMouseUp = (e) => {
            e.currentTarget.blur();
        };
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.disabled !== this.props.disabled ||
            nextProps.selected !== this.props.selected);
    }
    render() {
        const { values, selected } = this.props;
        return (React.createElement(SegmentedWrapper, { disabled: this.props.disabled, theme: this.props.theme }, values.map((button) => (React.createElement("button", { key: button, value: button, "data-selected": button === selected ? true : undefined, onMouseUp: this.onMouseUp, onClick: this.onClick }, button)))));
    }
}
